import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { ShoppingCart, Menu, X, Smartphone } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { LOGO, APP_URL } from "@/lib/config";

const LINKS = [
  ["/", "Home", "nav-home-link"],
  ["/servizi", "Servizi & Prodotti", "nav-services-link"],
  ["/galleria", "Galleria", "nav-gallery-link"],
  ["/recensisci", "Recensisci", "nav-review-link"],
  ["/#contatti", "Contatti", "nav-contacts-link"],
];

export default function Navbar() {
  const { count, setOpen } = useCart();
  const [mobile, setMobile] = useState(false);
  const cls = ({ isActive }) =>
    `font-display uppercase italic font-bold tracking-wider text-sm transition-colors duration-150 ${isActive ? "text-red-500" : "text-zinc-300 hover:text-white"}`;

  return (
    <header className="sticky top-0 z-50 bg-black/85 backdrop-blur-xl border-b border-red-900/30" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-20 flex items-center justify-between gap-6">
        <Link to="/" className="flex items-center gap-3" data-testid="header-logo-link">
          <img src={LOGO} alt="TMS Garage" className="h-14 w-auto rounded-sm" />
        </Link>
        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map(([to, label, id]) =>
            to.includes("#") ? (
              <a key={to} href={to} className={cls({ isActive: false })} data-testid={id}>{label}</a>
            ) : (
              <NavLink key={to} to={to} end={to === "/"} className={cls} data-testid={id}>{label}</NavLink>
            )
          )}
        </nav>
        <div className="flex items-center gap-3">
          {APP_URL && (
            <a href={APP_URL} className="hidden md:inline-flex btn-ghost !py-2 !px-4 text-xs" data-testid="header-app-link">
              <Smartphone size={15} /> App
            </a>
          )}
          <button onClick={() => setOpen(true)} className="relative p-2.5 border border-zinc-800 hover:border-red-600 transition-colors" data-testid="header-cart-button" aria-label="Carrello">
            <ShoppingCart size={20} />
            {count > 0 && (
              <span className="absolute -top-2 -right-2 bg-red-600 text-white text-[11px] font-bold w-5 h-5 grid place-items-center rounded-full" data-testid="cart-count-badge">{count}</span>
            )}
          </button>
          <button className="lg:hidden p-2.5" onClick={() => setMobile(!mobile)} data-testid="mobile-menu-toggle" aria-label="Menu">
            {mobile ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {mobile && (
        <nav className="lg:hidden border-t border-zinc-900 bg-black px-5 py-4 flex flex-col gap-4" data-testid="mobile-menu">
          {LINKS.map(([to, label, id]) => (
            <a key={to} href={to} onClick={() => setMobile(false)} className="font-display uppercase italic font-bold tracking-wider text-zinc-200" data-testid={`mobile-${id}`}>{label}</a>
          ))}
        </nav>
      )}
    </header>
  );
}
